import React from "react";
import { FinancialContextProvider } from "../components/financial-management/FinancialContext";
import Helmet from "react-helmet";
const FinancialManagement: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>امور مالی</title>
      </Helmet>
      <FinancialContextProvider />
    </>
  );
};

export default FinancialManagement;
